import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 11 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.1 8.33v.517a.825.825 0 0 1 1.048 1.052l.51.001.853-.853-1.563-1.563-.848.847zM7.242 2.2l1.559 1.557L4.289 8.27 2.726 6.707 7.242 2.2zM9.12.322l1.559 1.559c.43.43.43 1.125 0 1.554l-7.366 7.367a.76.76 0 0 1-.47.194H.55a.55.55 0 0 1-.55-.55v-2.29c0-.154.088-.366.194-.471L7.564.32A1.1 1.1 0 0 1 9.12.322z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconEdit extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
